<template>
    <div key="attachment">
        <b-modal v-model="isVisible" hide-footer class="pt-8" header-class="p-0" content-class="custom-model-wrap">
            <template #modal-title="{ cancel }">
                <div class="title-block text-center p-2">{{ $translate('uploaded_file') }}</div>
                <div class="close-btn" @click="cancel()">×</div>
            </template>
            <b-img :src="model.url" v-if="['jpg', 'jpeg', 'png'].includes(
                model && model.file_extension
            )" fluid alt="Responsive image"></b-img>
            <a v-else-if="['xls', 'xlsx'].includes(
                model && model.file_extension
            )
                " :href="model && model.url">
                <div class="btn btn-success btn-sm">
                    <i v-b-tooltip.hover :title="$translate('click_to_download')" class="fa-solid fa-file-excel fa-2x"></i>
                </div>
            </a>
            <a v-else-if="model && model.file_extension == 'pdf'" :href="model && model.url">
                <div class="btn delete-button btn-sm">
                    <i v-b-tooltip.hover :title="$translate('click_to_download')" class="fa fa-file-pdf fa-2x"></i>
                </div>
            </a>
            <a v-else :href="model && model.url">
                <div class="btn btn-success btn-sm">
                    <i class="fa fa-file fa-2x"></i>
                </div>
            </a>

            <br />
            <div class="row px-3">
                <b-list-group class="mt-2 col-12 col-sm-9">
                    <b-list-group-item class="d-inline-flex p-2">
                        <!--file name input to rename the file before upload-->
                        <b-form-input placeholder="File name..." v-model="model.name" required />
                        <!--file extension-->
                        <span class="d-inline-flex align-items-center text-muted ml-1 mr-3">.{{ model.file_extension
                        }}</span>
                        <b-form-textarea placeholder="Description"  v-model="model.description"
                                      ref="inputField"  ></b-form-textarea>
                    </b-list-group-item>
                </b-list-group>
                <b-col cols="12" sm="3" class="align-self-center pt-2">
                    <b-button type="submit" :disabled="disabled" variant="info" class="btn-fw" @click="renameFileName(model.index, model.name,model.description)">
                        {{ $translate('update') }}
                    </b-button>
                </b-col>
            </div>
            <div class="text-center mt-3">
                <b-button id="delete-attachment" :disabled="disabled" variant="delete-button" class="btn-fw ms-2" v-if="hasPermissionDelete"
                    @click="deleteAttachment(model.hash)">{{ $deleteLabel() }}</b-button>

            </div>
        </b-modal>
        <b-modal v-model="showModal" id="add-attachments-modal" centered header-class="p-0"
            footer-class="d-flex justify-content-center border-0" content-class="custom-model-wrap" hide-footer  @paste="onPaste">
            <template #modal-title="{ cancel }">
                <div class="text-center">
                    <div class="title-block text-center p-2">{{ $translate('files_upload') }}</div>
                    <div class="close-btn" @click="cancel()">×</div>
                </div>
            </template>
                <b-overlay :show="loading" rounded="sm">
                   
                <b-row>
                    <b-col sm="12" xl="12" v-if="this.filelist.length" v-cloak>
                        <!--show a list of the selected files, with an input to (optionally) rename the file before upload-->
                        <b-list-group>
                            <b-list-group-item  class="d-flex align-items-center p-2" v-for="(file, i) in filelist" :key="i">
                                <!--file name input to rename the file before upload-->
                                <b-form-group :label="$translate('file_name_placeholder')" label-for="rename-file-input-small" class="mb-0 flex-grow-1">
                                <b-form-input placeholder="File name..." v-model="filelist[i].fileName" required
                                    @change="renameFile(i, filelist[i].fileName)"  ref="inputField"  @click="selectText(i)" />
                                </b-form-group>
                                <!--file extension-->
                                <span class="text-muted mx-2">.{{ filelist[i].extension
                                }}</span>
                                <b-form-group :label="$translate('description')" label-for="rename-file-input-small-1" class="mb-0 flex-grow-1">
                                <b-form-textarea placeholder="Description" v-model="filelist[i].description" 
                                      ref="inputField"  ></b-form-textarea>
                                </b-form-group>
                                &nbsp;&nbsp;
                                <!--remove file from list (and from upload)-->
                                <b-button id="remove-file-btn" :disabled="disabled" variant="outline-danger" size="sm" @click="remove(filelist.indexOf(file))">
                                    <b-icon-trash></b-icon-trash>
                                </b-button>
                            </b-list-group-item>
                        </b-list-group>
                    </b-col>

                    <!--this column contains the file drop area-->
                    <!--its width is automatically set based on existance of the file list column and breakpoint-->
                    <b-col class="file-drop-column my-4 my-xl-0 p-0">
                        <div class="file-drop-area bg-light" @dragover="dragover" @drop="drop"  @paste="onPaste" >
                            <!--we need an actual file input in order to have the drag&drop functionality-->
                            <!--and the File object(s) containing the files dropped-->
                            <!--We keep it invisible because we want to display something different than a file input-->
                            <input type="file" name="file-input" id="file-input" class="file-input invisible"
                                @change="onChange" />

                            <!--clicking on this label will trigger the clicked event on the file input-->
                            <!--this will cause the 'choose file' system dialog-->
                            <label for="file-input" class="w-100 text-center attachment-cursor cursor-pointer text-muted m-0 px-3 py-5">
                                <p>
                                    <b-icon-cloud-upload-fill font-scale="3"></b-icon-cloud-upload-fill>
                                </p>
                                <div>
                                    <p class="mb-0">{{ $translate('upload_file_note') }}</p>
                                    <p class="mb-0">
                                        <span class="text-info">{{ $translate('select_from_computer') }}</span>
                                    </p>
                                </div>
                            </label>
                        </div>
                    </b-col>
                </b-row>

                <div class="text-center mt-4">
                    <b-button id="close-model-btn" :disabled="disabled" variant="info" @click="$bvModal.hide('add-attachments-modal')" class="me-3 btn-fw">
                        {{ $cancelLabel() }}
                    </b-button>
                    <b-button id="upload_cloud_btn"  type="submit" :disabled="!filelist.length" variant="info" class="btn-fw" @click="onSubmit()">
                        {{ $translate('upload_files') }}
                    </b-button>
                </div>
            </b-overlay>
        </b-modal>
        <b-row class="align-items-center">
            <b-col cols="9" md="11">
                <b-container fluid class="form-control ">
                    <b-row class="attachment">
                        <b-col v-for="(item, index) in attachments" :key="index" md="2" class="mt-2 mt-md-0">
                            <button :id="'image-file-btn'+index" type="button" v-if="['jpg', 'jpeg', 'png'].includes(
                                item.file_extension
                            )" @click="setModel(item, index)">
                                <b-img :height="imageHeight" :width="imageWidth" :src="item.url" alt="Image 1"></b-img>
                            </button>
                            <button :id="'excel-file-btn'+index" type="button" v-else-if="['xls', 'xlsx'].includes(
                                item.file_extension
                            )
                                " @click="setModel(item, index)">
                                <div class="btn btn-success btn-sm">
                                    <i class="fa-solid fa-file-excel fa-2x"></i>
                                </div>
                            </button>
                            <button :id="'pdf-file-btn'+index" type="button" v-else-if="item.file_extension == 'pdf'" @click="setModel(item, index)">
                                <div class="btn delete-button btn-sm">
                                    <i class="fa-solid fa-file-pdf fa-2x"></i>
                                </div>
                            </button>
                            <button :id="'file-btn'+index" type="button" v-else @click="setModel(item, index)">
                                <div class="btn btn-success btn-sm">
                                    <i class="fa fa-file fa-2x"></i>
                                </div>
                            </button>
                            <div>
                                <label>{{ item.name ? item.name + '.' + item.file_extension : '' }}</label><br>
                                <div class="mt-1 mb-2" v-if="item.updated_at">
                                    <label><b>{{ $translate('upload_on') }}</b></label>
                                    <label>{{ item.created_at | displayTime }}</label>
                                </div>
                            </div>
                        </b-col>
                        <b-col v-if="!attachments.length">
                            <h4 class="text-black">{{ $translate('no_attachments_submitted') }}</h4>
                        </b-col>
                    </b-row>
                </b-container>
            </b-col>
            <b-col cols="3" md="1">
                <b-button id="cloud-file-upload-btn" :disabled="disabled" variant="info" @click="showModalFn">
                    <b-icon icon="cloud-upload"></b-icon>
                </b-button>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import locationMixins from '@/mixins/locationMixins'

export default {
    name: 'customers-attachments',

    mixins: [popupMixins, permissionsMixins, locationMixins],
    props: {
        disabled: { type: Boolean },
    },

    data() {
        return {
            imageHeight: 60,
            imageWidth: 60,
            componentName: 'Customer Attachment',
            submitting: false,
            extension: '',
            model: {
                "name": null,
                "description" : null,
            },
            isVisible: false,
            // attachmentName: '',
            filelist: [],
            // attachment: null,
            // Controls Filepicker modal
            showModal: false,
            loading: false,
        }
    },
    computed: {
        customer() {
            return this.$store.state.customers.item
        },
        attachments() {
            return this.$store.state.customerAttachmentsStore.attachments
        },
        mediaBaseUrl() {
            return this.$store.getters['mediaBaseUrl']
        },
    },
    filters: {
        displayTime(date) {
            const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
            console.log('timezone', timezone)
            if (date) {
                return new Date(date).toLocaleString('en-US', {
                    timeZone: timezone,
                })
            } else {
                return ''
            }
        },

    },
    watch: {
        'customer.attachments': {
            handler: function (items) {
                this.storeAttachments(items)
            },
            deep: true,
        },
    },
    mounted() {
        if (!this.customer) {
            this.storeAttachments([])
        } else {
            const { attachments } = this.customer
            this.storeAttachments(attachments)
        }
        // this.$store.dispatch('js_report/fetchCredentials')
        document.addEventListener('paste', this.handlePaste);
    },
    methods: {
        onSubmit() {
            event.preventDefault()
            this.loading = true;
            console.log(
                'Perfect! Now implement some way to upload these files: '
            )
            console.log(this.filelist)
            this.createAttachment()
                .then(() => {
                    this.loading = false;
                })
                .catch((error) => {
                    console.log(error)
                    this.loading = false;
                })
        },

        storeAttachments(attachments) {           
            this.$store.dispatch(
                'customerAttachmentsStore/load',
                attachments || []
            )
        },
        renameFile(fileIndex, newName) {
            const file = this.filelist[fileIndex].file
            var newFile = new File(
                [file],
                `${newName}.${this.filelist[fileIndex].extension}`,
                {
                    type: file.type,
                }
            )

            // Rebuild File Obj for file list array
            const fileName = newFile.name.replace(/\.[^/.]+$/, '') //extract filename (no extension) from the file full name
            const extension = newFile.name.split('.').pop() //extract

            this.filelist[fileIndex] = {
                fileName: fileName,
                extension: extension,
                file: newFile,
            }
        },
        renameFileName(fileIndex, newName,newDescription) {
            const file = this.attachments[fileIndex]
            if (!newName) {
                this.doToast(this.$translate('error'), this.$translate('file_name_required'), 'danger')
                return false
            }
            file.name = newName
            file.description = newDescription
            this.attachments[fileIndex] = file
            this.$store.commit('customerAttachmentsStore/SET_CHANGED', true)
            this.updateAttachment(this.attachments)
            this.isVisible = false
        },
        onChange(event) {
            let allowedTypes = this.$allowedTypes
            let uploadedFileName = event.target.files[0].name;
            let fileExtension = uploadedFileName.split('.').pop();
            let maxFileSize = this.$maxFileSize
            console.log("event.target.files", event.target.files)
            if (!allowedTypes.includes(fileExtension.toLowerCase())) {
                this.doToast(this.$translate('error'), this.$translate('invalid_file_type'), 'danger')
                return false;
            }
            if (maxFileSize < event.target.files[0].size) {
                this.doToast(this.$translate('error'), this.$translate('file_size_alert'), 'danger')
                return false
            }
            const fileArray = [...event.target.files] //put the files in a temporary array
            fileArray.forEach(file => {
                const fileName = file.name.replace(/\.[^/.]+$/, '') //extract filename (no extension) from the file full name
                const extension = file.name.split('.').pop() //extract extensionfrom the file fullname
                this.filelist.push({
                    fileName: fileName,
                    extension: extension,
                    file: file,
                    description : null,
                }) //store selected files and additional data in our array
            })
        },
        onChangeDrop(event) {
            console.log('event_data---',event.dataTransfer.files[0]);
            let allowedTypes = this.$allowedTypes
            let uploadedFileName = event.dataTransfer.files[0].name;
            let fileExtension = uploadedFileName.split('.').pop();
            let maxFileSize = this.$maxFileSize
            console.log("event.target.files", event.target.files)
            if (!allowedTypes.includes(fileExtension.toLowerCase())) {
                this.doToast(this.$translate('error'), this.$translate('invalid_file_type'), 'danger')
                return false;
            }
            if (maxFileSize < event.dataTransfer.files[0].size) {
                this.doToast(this.$translate('error'), this.$translate('file_size_alert'), 'danger')
                return false
            }
            const fileArray = [...event.dataTransfer.files] //put the files in a temporary array
            fileArray.forEach(file => {
                const fileName = file.name.replace(/\.[^/.]+$/, '') //extract filename (no extension) from the file full name
                const extension = file.name.split('.').pop() //extract extensionfrom the file fullname
                this.filelist.push({
                    fileName: fileName,
                    extension: extension,
                    file: file,
                    description : null,
                }) //store selected files and additional data in our array
            })
        },
        remove(i) {
            this.filelist.splice(i, 1)
        },
        removeAll(i) {
            this.filelist.splice(i, i.length)
        },
        async setModel(item, i) {
            this.model = { ...item, index: i }
            console.log('this is model----',this.model);
            // await this.loadFileData(this.model.url);
            this.isVisible = true
        },

        dragover(event) {
            event.preventDefault()
        },
        drop(event) {
            event.preventDefault()
            this.onChangeDrop(event)
        },
        onPaste(event) {
            console.log('on pastes is called');
            const clipboardData = event.clipboardData || window.clipboardData;
            if (clipboardData) {
            const items = clipboardData.items;
            const fileList = [];
            for (let i = 0; i < items.length; i++) {
                const item = items[i];
                if (item.kind === 'file') {
                const file = item.getAsFile();
                fileList.push(file);
                }
            }
            this.handleFiles(fileList);
            }
        },
        handlePaste(event) {
           
            const modalElement = document.getElementById('add-attachments-modal');
           
            
            if (modalElement) {
                this.onPaste(event);
            } else {
                console.log('Else is called');
            }
        },

        handleFiles(fileList) {
            // Common functionality
            let allowedTypes = this.$allowedTypes;
            let maxFileSize = this.$maxFileSize;
            
            fileList.forEach(file => {
            const uploadedFileName = file.name;
            const fileExtension = uploadedFileName.split('.').pop();
            
            if (!allowedTypes.includes(fileExtension.toLowerCase())) {
                this.doToast(this.$translate('error'), this.$translate('invalid_file_type'), 'danger');
                return false;
            }
            
            if (maxFileSize < file.size) {
                this.doToast(this.$translate('error'), this.$translate('file_size_alert'), 'danger');
                return false;
            }
            
            const fileName = uploadedFileName.replace(/\.[^/.]+$/, '');
            const extension = uploadedFileName.split('.').pop();
            this.filelist.push({
                fileName: fileName,
                extension: extension,
                file: file,
                description : null,
            });
            });

       },
   
        async updateAttachment(newFiles) {
            this.$store.dispatch('customerAttachmentsStore/merge', {
                newFiles,
            })
        },
        async createAttachment() {
            console.log('upload event', this.filelist)
            try {
                this.submitting = true
                // const files = this.filelist.map(file => file.file)
                const files = this.filelist.map(file => ({
                        file: file.file,
                        description: file.description // Include description
                    }));

                    console.log('final-files--',files);
                const p = await this.getCurrentLocation()
                console.log('coordinates', p)
                const lat = p.coords.latitude
                const long = p.coords.longitude

                        // Preparing metadata for each file
                // const fileMetadata = this.filelist.map(file => ({
                //     name: file.file.name,
                //     description: file.fileDescription,  // Assuming each file has a fileDescription property
                // }))
                // const file_extension =  files[0].name.split('.').pop()
                let { keys } = await this.$store.dispatch(
                    's3files/s3uploadOrder',
                     files
                )
                let url = []
                keys.forEach(key => {
                    url.push(`${this.mediaBaseUrl}/${key}`)
                })
                // const newFiles = []
                // files.forEach((element, i) => {
                //     newFiles.push({
                //         name: element.name.replace(/\.[^/.]+$/, ''),
                //         url: url[i],
                //         file_extension: element.name.split('.').pop(),
                //         lat: lat,
                //         long: long,
                //         description : element.fileDescription
                //     })
                // })
                const newFiles = files.map((element, i) => ({
                            name: element.file.name.replace(/\.[^/.]+$/, ''),
                            url: url[i],
                            file_extension: element.file.name.split('.').pop(),
                            lat: lat,
                            long: long,
                            description: element.description // Use description
                        }));

                console.log('this is files---',newFiles);
                this.$store.dispatch('customerAttachmentsStore/merge', {
                    newFiles,
                })

                // Hide modal after success
                this.showModal = false

                this.genericToast(
                    this.componentName,
                    this.$translate('uploaded'),
                    'success',
                    this.$translate(`attachment_uploaded`)
                )
                this.removeAll(this.filelist)
            } catch (error) {
                console.error('addAttachement', error)

                this.doToast(this.$translate('error'), this.$translate('error_storing_attachment'), 'danger')
            } finally {
                this.submitting = false
            }
        },
        deleteAttachment(hash) {
            this.$store.dispatch('customerAttachmentsStore/delete', hash)
            this.isVisible = false
        },
        async showModalFn(){
            if(!this.showModal){
                await this.$store.dispatch('js_report/fetchCredentials')
            }
            this.showModal = !this.showModal
        },
        selectText(i) {
        // Use $refs to access the input element and call select() on it
        this.$refs.inputField[i].select();
        },
        // async loadFileData(s3url) {
        //     await this.$store.dispatch('js_report/fetchCredentials');
        //     const description = await this.$store.dispatch('s3files/getObjectMetadata');
        //     console.log('description-----',description);
        //     this.model.description = description;
        // }
    },
}
</script>

<style scoped>
    .attachment-cursor{ cursor: pointer; }
</style>
